export const translations = {
    en: {
        nav: {
            home: "Home",
            about: "About",
            services: "Services",
            coverage: "Coverage",
            contact: "Contact",
            callNow: "Call Now",
        },
        hero: {
            overline: "Trusted Financial Partner • Est. 2019",
            title_a: "Loans built around",
            title_b: "your life in Gujarat.",
            subtitle:
                "Vehicle, car, commercial, home and mortgage loans plus complete vehicle insurance — delivered with transparency, speed and a personal touch from Ahmedabad.",
            cta_call: "Call +91 78610 72065",
            cta_whatsapp: "Chat on WhatsApp",
            badge_1: "RBI-aligned partners",
            badge_2: "Doorstep service",
            badge_3: "Quick approvals",
            quick_stats: "Quick Stats",
            stat_years: "Years in business",
            stat_loans: "Loans facilitated",
            stat_districts: "Gujarat districts",
            stat_satisfaction: "Customer satisfaction",
            talk_to_us: "Talk to us",
        },
        about: {
            overline: "About Us",
            title: "A trusted financial partner serving Gujarat since 2019.",
            p1: "Shree Ganesh Financial Service has been helping families, drivers, fleet owners and small businesses across Gujarat secure the right loan — fast, fairly and without the runaround.",
            p2: "From a humble start in 2019, we have grown into a dependable name in Ahmedabad and beyond, building long-term relationships through honest advice, transparent paperwork and personal service.",
            stat1_label: "Years serving Gujarat",
            stat2_label: "Loans facilitated",
            stat3_label: "Districts covered",
            stat4_label: "Customer satisfaction",
        },
        services: {
            overline: "What we offer",
            title: "Comprehensive loan & insurance solutions.",
            subtitle:
                "Choose from a range of financial products designed for individuals and businesses across Gujarat.",
            items: {
                vehicle: {
                    title: "Vehicle Loans",
                    desc: "Two-wheelers, three-wheelers and personal vehicles — financed across Gujarat with flexible tenures.",
                },
                car: {
                    title: "Car Loans",
                    desc: "New and used car loans with competitive rates, minimal paperwork and quick approvals.",
                },
                commercial: {
                    title: "Commercial Vehicle Loans",
                    desc: "Trucks, tempos, taxis and fleet financing for transporters and businesses across Gujarat.",
                },
                home: {
                    title: "Home Loans (Ahmedabad)",
                    desc: "Affordable home loans for Ahmedabad — new purchase, resale and balance transfer with expert guidance.",
                },
                mortgage: {
                    title: "Mortgage Loans",
                    desc: "Loan against property — residential, commercial or industrial — to unlock the value of what you own.",
                },
                insurance: {
                    title: "Vehicle Insurance",
                    desc: "Comprehensive and third-party vehicle insurance for cars, two-wheelers and commercial vehicles.",
                },
            },
            cta: "Discuss your requirement",
        },
        why: {
            overline: "Why choose us",
            title: "Built on trust. Delivered with speed.",
            items: {
                a_title: "Fast processing",
                a_desc: "Most loan applications are processed within 24–72 hours, with end-to-end follow-up.",
                b_title: "Transparent terms",
                b_desc: "No hidden charges. Every fee, rate and condition is explained upfront, in your language.",
                c_title: "High approval rate",
                c_desc: "Multi-lender network and pre-screening means stronger approvals — even for first-time borrowers.",
                d_title: "Doorstep service",
                d_desc: "Document pickup, signing and verification done at your home or office across Gujarat.",
            },
        },
        coverage: {
            overline: "Coverage",
            title: "Serving customers across Gujarat.",
            subtitle:
                "Vehicle, commercial, mortgage and insurance services run state-wide. Home loans are currently offered for Ahmedabad properties.",
            cities: [
                "Ahmedabad",
                "Gandhinagar",
                "Surat",
                "Vadodara",
                "Rajkot",
                "Bhavnagar",
                "Jamnagar",
                "Junagadh",
                "Anand",
                "Nadiad",
                "Mehsana",
                "Bharuch",
                "Navsari",
                "Vapi",
                "Morbi",
                "Patan",
                "Palanpur",
                "Porbandar",
                "Kheda",
                "Surendranagar",
            ],
            note: "Don't see your city? Call us — we likely cover it.",
        },
        contact: {
            overline: "Get in touch",
            title: "Talk to us directly.",
            subtitle:
                "No forms, no waiting. Reach out by phone or WhatsApp and speak with our team today.",
            address_label: "Office address",
            phone_label: "Phone",
            email_label: "Email",
            hours_label: "Working hours",
            hours_value: "Mon – Sat • 10:00 AM – 7:30 PM",
            sunday: "Sunday: By appointment",
            cta_call: "Call us now",
            cta_whatsapp: "Message on WhatsApp",
            map_title: "Find us in Ahmedabad",
        },
        footer: {
            tagline:
                "Trusted financial partner serving customers across Gujarat since 2019.",
            quick: "Quick Links",
            services: "Services",
            contact: "Contact",
            rights: "All rights reserved.",
        },
        lang_toggle: {
            en: "EN",
            gu: "ગુ",
            label: "Language",
        },
    },
    gu: {
        nav: {
            home: "હોમ",
            about: "અમારા વિશે",
            services: "સેવાઓ",
            coverage: "વ્યાપ",
            contact: "સંપર્ક",
            callNow: "કૉલ કરો",
        },
        hero: {
            overline: "વિશ્વસનીય નાણાકીય ભાગીદાર • સ્થાપના 2019",
            title_a: "તમારી જરૂરિયાત મુજબ",
            title_b: "ગુજરાતભરમાં લોન.",
            subtitle:
                "વાહન, કાર, કોમર્શિયલ, હોમ અને મોર્ગેજ લોન સાથે સંપૂર્ણ વાહન વીમો — પારદર્શી, ઝડપી અને વ્યક્તિગત સેવા સાથે અમદાવાદથી.",
            cta_call: "કૉલ +91 78610 72065",
            cta_whatsapp: "WhatsApp પર ચેટ કરો",
            badge_1: "RBI-અનુરૂપ ભાગીદારો",
            badge_2: "ઘરે-ઘરે સેવા",
            badge_3: "ઝડપી મંજૂરી",
            quick_stats: "ઝડપી આંકડા",
            stat_years: "વર્ષનો અનુભવ",
            stat_loans: "લોન મંજૂર",
            stat_districts: "ગુજરાત જિલ્લાઓ",
            stat_satisfaction: "ગ્રાહક સંતોષ",
            talk_to_us: "અમારી સાથે વાત કરો",
        },
        about: {
            overline: "અમારા વિશે",
            title: "2019 થી ગુજરાતની વિશ્વસનીય નાણાકીય ભાગીદાર.",
            p1: "શ્રી ગણેશ ફાઇનાન્શિયલ સર્વિસ ગુજરાતભરના પરિવારો, ડ્રાઇવરો, ફ્લીટ માલિકો અને નાના વ્યવસાયોને યોગ્ય લોન મેળવવામાં મદદ કરે છે — ઝડપથી, ન્યાયપૂર્વક અને કોઈ ગડબડ વગર.",
            p2: "2019 માં નાનકડી શરૂઆતથી લઈને, અમે અમદાવાદ અને બહારના વિસ્તારોમાં ભરોસાપાત્ર નામ બન્યા છીએ. પ્રામાણિક સલાહ, પારદર્શી દસ્તાવેજો અને વ્યક્તિગત સેવા દ્વારા લાંબા ગાળાના સંબંધો બાંધીએ છીએ.",
            stat1_label: "વર્ષનો અનુભવ",
            stat2_label: "લોન મંજૂર",
            stat3_label: "જિલ્લાઓ આવરી લીધા",
            stat4_label: "ગ્રાહક સંતોષ",
        },
        services: {
            overline: "અમારી સેવાઓ",
            title: "વ્યાપક લોન અને વીમા સોલ્યુશન્સ.",
            subtitle:
                "ગુજરાતભરના વ્યક્તિઓ અને વ્યવસાયો માટે ડિઝાઇન કરેલ વિવિધ નાણાકીય પ્રોડક્ટ્સમાંથી પસંદ કરો.",
            items: {
                vehicle: {
                    title: "વાહન લોન",
                    desc: "ટુ-વ્હીલર, થ્રી-વ્હીલર અને વ્યક્તિગત વાહનો — ગુજરાતભરમાં લવચીક મુદત સાથે.",
                },
                car: {
                    title: "કાર લોન",
                    desc: "નવી અને જૂની કાર માટેની લોન - સ્પર્ધાત્મક દરો, ઓછા દસ્તાવેજો અને ઝડપી મંજૂરી સાથે.",
                },
                commercial: {
                    title: "કોમર્શિયલ વાહન લોન",
                    desc: "ટ્રક, ટેમ્પો, ટેક્સી અને ફ્લીટ ફાઇનાન્સિંગ — ટ્રાન્સપોર્ટરો અને વ્યવસાયો માટે.",
                },
                home: {
                    title: "હોમ લોન (અમદાવાદ)",
                    desc: "અમદાવાદ માટે પોસાય તેવી હોમ લોન — નવી ખરીદી, રિસેલ અને બેલેન્સ ટ્રાન્સફર.",
                },
                mortgage: {
                    title: "મોર્ગેજ લોન",
                    desc: "મિલકત સામે લોન — રહેણાંક, કોમર્શિયલ અથવા ઔદ્યોગિક — તમારી મિલકતની કિંમત મેળવો.",
                },
                insurance: {
                    title: "વાહન વીમો",
                    desc: "કાર, ટુ-વ્હીલર અને કોમર્શિયલ વાહનો માટે વ્યાપક અને થર્ડ-પાર્ટી વાહન વીમો.",
                },
            },
            cta: "તમારી જરૂરિયાત જણાવો",
        },
        why: {
            overline: "અમને કેમ પસંદ કરો",
            title: "ભરોસા પર બનેલ. ઝડપથી પહોંચાડેલ.",
            items: {
                a_title: "ઝડપી પ્રક્રિયા",
                a_desc: "મોટાભાગની લોન અરજીઓ 24–72 કલાકમાં પ્રક્રિયા થાય છે — સંપૂર્ણ ફોલો-અપ સાથે.",
                b_title: "પારદર્શી શરતો",
                b_desc: "કોઈ છુપાયેલા ખર્ચ નથી. દરેક ફી, દર અને શરત તમારી ભાષામાં અગાઉથી સમજાવેલ.",
                c_title: "ઉચ્ચ મંજૂરી દર",
                c_desc: "મલ્ટિ-લેન્ડર નેટવર્ક અને પ્રી-સ્ક્રીનિંગથી મજબૂત મંજૂરી — પ્રથમ વખતના ઉધાર લેનારાઓ માટે પણ.",
                d_title: "ઘરે-ઘરે સેવા",
                d_desc: "દસ્તાવેજો લેવાનું, સહીઓ અને ચકાસણી તમારા ઘરે કે ઓફિસે — ગુજરાતભરમાં.",
            },
        },
        coverage: {
            overline: "વ્યાપ",
            title: "ગુજરાતભરના ગ્રાહકોની સેવા.",
            subtitle:
                "વાહન, કોમર્શિયલ, મોર્ગેજ અને વીમા સેવાઓ સમગ્ર રાજ્યમાં ઉપલબ્ધ છે. હોમ લોન હાલમાં અમદાવાદની મિલકતો માટે છે.",
            cities: [
                "અમદાવાદ",
                "ગાંધીનગર",
                "સુરત",
                "વડોદરા",
                "રાજકોટ",
                "ભાવનગર",
                "જામનગર",
                "જૂનાગઢ",
                "આણંદ",
                "નડિયાદ",
                "મહેસાણા",
                "ભરૂચ",
                "નવસારી",
                "વાપી",
                "મોરબી",
                "પાટણ",
                "પાલનપુર",
                "પોરબંદર",
                "ખેડા",
                "સુરેન્દ્રનગર",
            ],
            note: "તમારું શહેર દેખાતું નથી? કૉલ કરો — અમે કદાચ સેવા આપીએ છીએ.",
        },
        contact: {
            overline: "સંપર્કમાં રહો",
            title: "સીધી અમારી સાથે વાત કરો.",
            subtitle:
                "ફોર્મ નહીં, રાહ નહીં. ફોન કે WhatsApp દ્વારા આજે જ અમારી ટીમ સાથે વાત કરો.",
            address_label: "ઓફિસનું સરનામું",
            phone_label: "ફોન",
            email_label: "ઈમેલ",
            hours_label: "કાર્ય સમય",
            hours_value: "સોમ – શનિ • સવારે 10:00 – સાંજે 7:30",
            sunday: "રવિવાર: અપોઇન્ટમેન્ટ દ્વારા",
            cta_call: "હમણાં કૉલ કરો",
            cta_whatsapp: "WhatsApp પર સંદેશ મોકલો",
            map_title: "અમદાવાદમાં અમને શોધો",
        },
        footer: {
            tagline:
                "2019 થી ગુજરાતભરના ગ્રાહકોની સેવા કરતી વિશ્વસનીય નાણાકીય ભાગીદાર.",
            quick: "ઝડપી લિંક્સ",
            services: "સેવાઓ",
            contact: "સંપર્ક",
            rights: "બધા હક્કો અમારી પાસે છે.",
        },
        lang_toggle: {
            en: "EN",
            gu: "ગુ",
            label: "ભાષા",
        },
    },
};
